import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ITokenState {
  value: {
    token?: string;
    user?: any;
  };
}

const initialState: ITokenState = {
  value: { token: '', user: {} },
};
export const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loadTokenAction: (state: ITokenState, action: PayloadAction<{ user?: any; token?: string }>) => {
      state.value = { ...state.value, ...action.payload };
    },
  },
});
export const { loadTokenAction } = slice.actions;
// export const selectMenuPath = (state: RootState) => state.menu.value;

export const AuthReducer = slice.reducer;
